const Header = () => {
    return (
        <header>
            <h1>🐱 domestic <span className="specialStyle">animal</span> kingdom 🐶</h1>
            <h2> <span className="specialStyle">Choose</span> YOUR <span className="specialStyle">Favorite!</span> </h2>
        </header>
    )
}

export default Header;